import React from "react";
import { Box, Divider, Link, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { getGoogleMapsUrl } from "../../utils/googleMapsLink";
import { estimateWalkMinutes } from "../../utils/geo";
import PlaygroundRating from "./PlaygroundRating";

const PlaygroundList = ({ playgrounds, selectedId, onSelect }) => {
  const { t } = useTranslation();

  if (playgrounds.length === 0) {
    return (
      <Typography variant="body2" color="text.secondary" sx={{ p: 2 }}>
        {t("playgrounds.no_results")}
      </Typography>
    );
  }

  return (
    <Box sx={{ maxHeight: "70vh", overflowY: "auto" }}>
      {playgrounds.map((playground, index) => (
        <React.Fragment key={playground.id}>
          <Box
            onClick={() => onSelect(playground.id)}
            sx={{
              p: 2,
              cursor: "pointer",
              bgcolor:
                playground.id === selectedId ? "action.selected" : "transparent",
              "&:hover": { bgcolor: "action.hover" },
            }}
          >
            {index === 0 && typeof playground.distanceKm === "number" && (
              <Typography
                variant="caption"
                color="primary"
                fontWeight={700}
                sx={{ display: "block", mb: 0.25 }}
              >
                {t("playgrounds.nearest_label")}
              </Typography>
            )}
            <Typography variant="subtitle2" fontWeight={600}>
              {playground.name}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {playground.address}
              {typeof playground.distanceKm === "number" &&
                ` · ${playground.distanceKm.toFixed(1)} ${t("playgrounds.km_unit")} · ${t("playgrounds.walk_time", { minutes: estimateWalkMinutes(playground.distanceKm) })}`}
            </Typography>
            <PlaygroundRating
              rating={playground.rating}
              userRatingsTotal={playground.userRatingsTotal}
            />
            <Link
              href={getGoogleMapsUrl(playground)}
              target="_blank"
              rel="noopener noreferrer"
              variant="body2"
              onClick={(e) => e.stopPropagation()}
              sx={{ display: "inline-block", mt: 0.5 }}
            >
              {t("playgrounds.view_on_google_maps")}
            </Link>
          </Box>
          {index < playgrounds.length - 1 && <Divider />}
        </React.Fragment>
      ))}
    </Box>
  );
};

export default PlaygroundList;
